import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/plan-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const planKinds = {
  getAll: apiPathFunc(pathBase),
};
